import { render, staticRenderFns } from "./FileReadOnly.vue?vue&type=template&id=545f1971&"
import script from "./FileReadOnly.vue?vue&type=script&lang=js&"
export * from "./FileReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('545f1971')) {
      api.createRecord('545f1971', component.options)
    } else {
      api.reload('545f1971', component.options)
    }
    module.hot.accept("./FileReadOnly.vue?vue&type=template&id=545f1971&", function () {
      api.rerender('545f1971', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/file/FileReadOnly.vue"
export default component.exports